<template>
  <div class="base-feature-agent-location">
    <div class="base-feature-agent-location__wrap">
      <div class="base-feature-agent-location__wrap__form">
        <InputLocation
          id="find-location-agent"
          v-model="searchInput"
          origin-or-destination="origin"
          name="find-location-agent"
          placeholder="Masukkan kecamatan/kota"
          label="Cari agen terdekat"
          @input="onChange"
        />
        <OptionSelect
          v-if="showOption"
          class="option-select"
          decide-class-hover="hover-option-from"
          trigger-class-listener-on-scroll="option-select__content-from"
          style-display="z-index: 20;width: 100%"
          key-value="sub_district_name,district_name"
          :show-loading-search="typing"
          :data-list="listData"
          :capitalize="true"
          @click="chooseMe"
        />
      </div>
      <div class="base-feature-agent-location__wrap__btn">
        <Button
          id="btn_cek_agen_new"
          text="Cari agen"
          type-class="indigo-dark"
          :round="true"
          :disabled="checkDisabled"
          @click="findAgent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mixinMobile from '@/misc/mixinMobile';
import Button from "@/components/new-button/Button.vue";
import InputLocation from "./InputLocation.vue";
import OptionSelect from "@/components/new-option-select/OptionSelect.vue";
import AgentDistrictUseCase from "../app/usecase/agentDistrict";
import routeAlgo from "@/app/usecase/routeOrder";

export default {
  name: "FeatureSectionAgentLocationHome",
  components: {
    Button,
    InputLocation,
    OptionSelect,
  },
  mixins: [mixinMobile],
  data() {
    return {
      searchInput: '',
      showOption: false,
      typing: false,
      isClose: true,
      listData: {},
      searchDistrict: {
        district_name: "",
        sub_district_id: 0,
        sub_district_name: "",
      },
      debounce: {
        timeout: 0,
        duration: 1500,
      },
    }
  },
  computed: {
    checkDisabled() {
      return this.searchDistrict.sub_district_id < 1;
    }
  },
  mounted() {
    this.getLocation()
  },
  methods: {
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.success, this.error);
      }
    },
    async success(position) {
      const filtersLocation = [
        "é=e",
        "kota bks=kota bekasi",
        "south tarogong=tarogong kidul",
        "sanankulon=sanan kulon",
        "daerah=",
        "khusus=",
        "ibukota=",
        "ibu kota=",
        "kota=",
        "city=",
        "special=",
        "istimewa=",
        "region=",
        "kabupaten=",
        "kab=",
        "sub-district=",
        "kecamatan=",
        "kec=",
        "regency="
      ]
      await routeAlgo.getReverseRoute(position.coords.latitude, position.coords.longitude).then(
        async res => {
          const location = {
            district: res.data.district,
            subDistrict: res.data.sub_district,
            routeId: 0,
          }
          for (const filter of filtersLocation) {
            let [key, value] = filter.split('=')
            res.data.district = res.data.district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
            res.data.sub_district = res.data.sub_district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
            location.district = res.data.district
            location.subDistrict = res.data.sub_district
          }
          // set
          this.searchInput = location.subDistrict
          this.onChange(location.subDistrict)
          
          // await routeAlgo.getAllBySearch(`${location.subDistrict}, ${location.district}`).then(resRoute => {
          //   if (resRoute.data.length > 0) {
          //     // choose first index because based on the search result on the top
          //     location.district = resRoute.data[0].city
          //     location.subDistrict = resRoute.data[0].route
          //   }
          //   this.origin.route_code = location.subDistrict
          //   this.getListOriginSearch(location.subDistrict)
          // })
        }
      )
    },
    error() {
      console.error("Geolocation not allowed");
    },
    chooseMe(value) {
      this.searchDistrict = value;
      this.showOption = false;
      const picked = value.sub_district_name + ", " + value.district_name;
      this.searchInput = picked.toLowerCase();
    },
    onChange(value) {
      this.searchDistrict = {
        district_name: "",
        sub_district_id: 0,
        sub_district_name: "",
      };
      this.showOption = true;
      this.typing = true;
      if (value.length > 0) {
        try {
          if (this.debounce.timeout) {
            clearTimeout(this.debounce.timeout);
          }
          this.debounce.timeout = setTimeout(async () => {
            this.listData = await AgentDistrictUseCase.getAllDistrictBySearch(value);
            this.typing = false;
          }, this.debounce.duration);
        } catch (err) {
          this.typing = false;
        }
      } else {
        this.showOption = false;
        this.typing = false;
      }
    },
    findAgent() {
      if (this.searchDistrict.district_name) {
        localStorage.setItem(
          "location-agent",
          JSON.stringify(this.searchDistrict)
        );
        this.$router.push("/lokasi-agen");
        window.scrollTo(0, 0);
      }
    },
    closeOptionList() {
      this.isClose = !this.isClose;
      if (this.showOption) {
        this.showOption = false;
      } else if (
        !this.showOption &&
        !this.isClose &&
        this.searchDistrict.district_name
      ) {
        this.onChange(this.searchDistrict.district_name);
      } else if (
        !this.showOption &&
        !this.isClose &&
        !this.searchDistrict.district_name
      ) {
        this.onChange(this.searchInput);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.base-feature-agent-location {
  &__wrap {
    ::v-deep input[name='find-location-agent'] {
      text-transform: capitalize;
      font-size: 16px;
      color: $color-indigo-dark;
    }

    display: flex;
    padding: 30px 40px;

    @include for-size(mobile) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(mobile-landscape) {
      flex-direction: column;
      padding: 16px;
    }

    @media (min-width: 916px) and (max-width: 1023px) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(tablet-portrait) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(tablet-landscape-new) {
      flex-direction: column;
      padding: 16px;
    }

    @media (min-width: 690px) and (max-width: 690px) {
      flex-direction: column;
      padding: 16px;
    }

    &__form {
      width: 87.5%;

      @include for-size(mobile) {
        width: auto;
        margin-bottom: 20px;
      }

      @include for-size(mobile-landscape) {
        width: auto;
        margin-bottom: 20px;
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        width: auto;
        margin-bottom: 20px;
      }

      @include for-size(tablet-portrait) {
        width: auto;
        margin-bottom: 20px;
      }

      @include for-size(tablet-landscape-new) {
        width: auto;
        margin-bottom: 20px;
      }

      @media (min-width: 690px) and (max-width: 690px) {
        width: auto;
        margin-bottom: 20px;
      }

      .option-select {
        font-size: 14px;

        ::v-deep .lds-ellipsis {
          left: 42% !important;

          @include for-size(mobile) {
            left: 38% !important;
          }
        }
      }
    }

    &__btn {
      width: 12.5%;
      margin: auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      ::v-deep .disabled {
        border-radius: 250px;
        height: 62px;
        width: max-content;
        display: flex;
        justify-content: center;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        border: unset;
      }

      > div {
        height: 62px;
        width: max-content;
        display: flex;
        justify-content: center;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
      }

      @include for-size(mobile) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(mobile-landscape) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(tablet-portrait) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(tablet-landscape-new) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @media (min-width: 690px) and (max-width: 690px) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }
    }
  }
}
</style>
